// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { UnitBizType } from './UnitBizType';
/**
 * 元件 实体类
 * 代表平台的一个独立部件，可以是产品或应用
 */
export class Unit extends BaseEntity {
  /** 名称 : 名称，来自应用或产品的名称 */
  private _name: string;

  /** 设置：名称 */
  public get name() {
    return this._name;
  }

  /** 获取：名称 */
  public set name(value: string) {
    this._name = value;
  }

  /** 是否免费 : 是否免费，免费的元件所有人可以使用 */
  private _isFree: boolean;

  /** 设置：是否免费 */
  public get isFree() {
    return this._isFree;
  }

  /** 获取：是否免费 */
  public set isFree(value: boolean) {
    this._isFree = value;
  }

  /** 产品ID : 产品ID */
  private _productId: string;

  /** 设置：产品ID */
  public get productId() {
    return this._productId;
  }

  /** 获取：产品ID */
  public set productId(value: string) {
    this._productId = value;
  }

  /** 应用ID : 应用ID */
  private _aPPId: string;

  /** 设置：应用ID */
  public get aPPId() {
    return this._aPPId;
  }

  /** 获取：应用ID */
  public set aPPId(value: string) {
    this._aPPId = value;
  }

  /** 是否是平台模型 : 是否是平台官方模型 */
  private _isPlat: boolean;

  /** 设置：是否是平台模型 */
  public get isPlat() {
    return this._isPlat;
  }

  /** 获取：是否是平台模型 */
  public set isPlat(value: boolean) {
    this._isPlat = value;
  }

  /** 定价 : 模型定价，单位元 */
  private _price: number;

  /** 设置：定价 */
  public get price() {
    return this._price;
  }

  /** 获取：定价 */
  public set price(value: number) {
    this._price = value;
  }

  /** 浏览次数 : 浏览次数 */
  private _viewTimes: number;

  /** 设置：浏览次数 */
  public get viewTimes() {
    return this._viewTimes;
  }

  /** 获取：浏览次数 */
  public set viewTimes(value: number) {
    this._viewTimes = value;
  }

  /** 购买次数 : 购买次数 */
  private _buyTimes: number;

  /** 设置：购买次数 */
  public get buyTimes() {
    return this._buyTimes;
  }

  /** 获取：购买次数 */
  public set buyTimes(value: number) {
    this._buyTimes = value;
  }

  /** 使用次数 : 使用次数 */
  private _useTimes: number;

  /** 设置：使用次数 */
  public get useTimes() {
    return this._useTimes;
  }

  /** 获取：使用次数 */
  public set useTimes(value: number) {
    this._useTimes = value;
  }

  /** 介绍 : 元件在模型库中的介绍，以吸引用户购买和使用 */
  private _intro: string;

  /** 设置：介绍 */
  public get intro() {
    return this._intro;
  }

  /** 获取：介绍 */
  public set intro(value: string) {
    this._intro = value;
  }

  /** 业务分类 的ID */
  private _bizType_ID: string;

  /** 获取：业务分类 的ID */
  public get bizType_ID() {
    return this._bizType_ID;
  }

  /** 设置：业务分类 的ID */
  public set bizType_ID(value: string) {
    this._bizType_ID = value;
  }

  /** 业务分类  */
  private _bizType: UnitBizType;

  /** 获取：业务分类  */
  public get bizType() {
    return this._bizType;
  }

  /** 设置：业务分类  */
  public set bizType(value: UnitBizType) {
    this._bizType = value;
    if (value !== null) {
      this.bizType_ID = value.id;
    } else {
      this.bizType_ID = '';
    }
  }

  constructor() {
    super();
    this._name = '';
    this._isFree = false;
    this._productId = '';
    this._aPPId = '';
    this._isPlat = false;
    this._price = 0;
    this._viewTimes = 0;
    this._buyTimes = 0;
    this._useTimes = 0;
    this._intro = '';
    this._bizType_ID = '';
    this._bizType = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Unit, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.isFree = element.isFree;
      this.productId = element.productId;
      this.aPPId = element.aPPId;
      this.isPlat = element.isPlat;
      this.price = element.price;
      this.viewTimes = element.viewTimes;
      this.buyTimes = element.buyTimes;
      this.useTimes = element.useTimes;
      this.intro = element.intro;
      this.bizType_ID = element.bizType_ID;
      if (hasReference && element.bizType !== null) {
        this.bizType = element.bizType;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.isFree = json.IsFree;
    this.productId = json.ProductId;
    this.aPPId = json.APPId;
    this.isPlat = json.IsPlat;
    this.price = json.Price;
    this.viewTimes = json.ViewTimes;
    this.buyTimes = json.BuyTimes;
    this.useTimes = json.UseTimes;
    this.intro = json.Intro;
    this.bizType_ID = json.BizType_ID;
    // if (json.BizType !== null) {
    //   this.bizType = UnitBizType.Create(json.BizType);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.IsFree = this.isFree;
    json.ProductId = this.productId;
    json.APPId = this.aPPId;
    json.IsPlat = this.isPlat;
    json.Price = this.price;
    json.ViewTimes = this.viewTimes;
    json.BuyTimes = this.buyTimes;
    json.UseTimes = this.useTimes;
    json.Intro = this.intro;
    json.BizType_ID = this.bizType_ID;
  }

  static Create(json: any): Unit {
    const unit = new Unit();
    unit.Deserialize(json);
    unit.json = json;
    return unit;
  }
}
